import "@hotwired/turbo-rails"
import "./controllers"
import "./components/app"

import "trix"
import "@rails/actiontext"

import ahoy from 'ahoy.js';

document.addEventListener("turbo:load", () => {
  ahoy.trackView();
});